import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Formik } from "formik";
import Button from "components/Button";
import OtpTimmer from "components/OtpTimer";
import SuccessMsg from "components/SuccessMsg";
import OTPInput from "components/FormElements/OTPInput";
import AlertModal from "components/AlertModal";
import KeyIcon from "assets/svg/ForgetPasswordKeyIcon";
import { otpVerification } from "redux/actions/otpVerification";
import { getAuthInitialValues, VALIDATION_SCHEMA } from "utils/otpUtils";
import { Heading, SubHeading } from "styles/pages/otp";
import { emailOtp } from "redux/actions/otpVerification";

import {
  RegistrationContainer,
  FormContainer,
  InputField,
  Footer,
} from "styles/pages/global";
import { registerUser } from "redux/actions/registerUser";
import { useText } from "locales/useGetText";

const VerifyOTP = ({ props }) => {
  const regiterEmail = props?.values?.email;
  const locale = useText("verifyOtp");
  const dispatch = useDispatch();
  const [successState, setSuccessState] = useState(false);
  const [response, setResponse] = useState({
    paload: "",
    buttonName: "OK",
    navigationLink: "/",
    heading: locale('successHeading'),
    description: locale('successDescription')
  });

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const formSubmit = async (props) => {
    const { submitForm, validateForm, setTouched, isValid } = props;
    submitForm().then(async () => {
      if (isValid) {
        let data = {
          email: regiterEmail,
          otp: props?.values?.otp
        }
        const response = await dispatch(otpVerification(data));
        if (response?.data?.success) {
          registerUserApiCall()
        } else {
          setSuccessState(false)
          setModalContent(response?.data?.error?.message)
          setModalLink("")
          toggleModal()
        }
        window.scrollTo(0, 0);
        validateForm();
        setTouched({});
      }
    });
  };

  const registerUserApiCall = async () => {
    let data = {
      emailAddress: props?.values?.email,
      password: props?.values?.password,
      confirmPassword: props?.values?.password,

      customerName: props?.values?.name,
      contactNumber: props?.values?.phoneNumber,
      locationName: props?.values?.businessName,
      locationAddress: {
        name: props?.values?.name,
        contactNumber: props?.values?.phoneNumber,
        locationName: props?.values?.businessName,
        street: props?.values?.address,
        city: props?.values?.city,
        state: props?.values?.state,
        zipCode: props?.values?.zip,
        country: props?.values?.country
      },
      businessInfo: {
        taxId: props?.values?.taxId,
        dnsDuns: props?.values?.dnbNum,
        businessUrl: props?.values?.businessUrl,
        businessDescription: props?.values?.businessDesc,
      },
      billingAddress: {
        name: props?.values?.billName,
        contactNumber: props?.values?.billPhoneNumber,
        locationName: props?.values?.billContactName,
        street: props?.values?.billAddress,
        city: props?.values?.billCity,
        state: props?.values?.billState,
        zipCode: props?.values?.billZip,
        country: props?.values?.country
      },
      billToEmailAddress: props?.values?.billingContactEmail,
      otherContactEmail: props?.values?.otherContactEmail
    };
    const response = await dispatch(registerUser(data));
    if (response?.data?.success) {
      setSuccessState(true)
      setResponse({
        ...response,
        paload: "",
        buttonName: "OK",
        navigationLink: "/",
        heading: locale('successHeading'),
        description: locale('successDescription')
      })
    } else {
      setModalContent(response?.data?.error?.message);
      setModalLink("");
      toggleModal();
    }
  }

  const emailOtpFun = async () => {
    let data = {
      email: props?.values?.email,
      name: props?.values?.name,
    };
    const response = await dispatch(emailOtp(data));
    if (!response?.data?.success) {
      setModalContent(response?.data?.error?.message);
      setModalLink("");
      toggleModal();
    }
  };
  const formFields = () => {
    return (
      <>
        {!successState ? (
          <>
            <Heading className="text-center">{locale('verifyYourEmailHeading')}</Heading>
            <SubHeading className="text-center">
             {locale('verifyEmailDescription')}
            </SubHeading>
            <Formik
              initialValues={getAuthInitialValues()}
              validationSchema={VALIDATION_SCHEMA}
              onSubmit={() => { }}
            >
              {(props) => {
                const { isValid, dirty } = props;
                return (
                  <Form>
                    <FormContainer>
                      <InputField>
                        <OTPInput name="otp" numInputs="6" />
                      </InputField>

                      <Footer>
                        <div style={{ "width": "150px", margin: "0 auto" }}>
                          <Button
                            disabled={!(isValid && dirty)}
                            handleClick={() => formSubmit(props)}
                          >
                           {locale('verifyEmailButton')}
                          </Button>
                        </div>
                      </Footer>

                      <OtpTimmer btnTxt={locale('resendOtp')} callBack={() => {
                        emailOtpFun()
                      }} />
                    </FormContainer>
                  </Form>
                );
              }}
            </Formik>
          </>
        ) :
          (
            <RegistrationContainer className="verify-email">
              <SuccessMsg response={response} icon={KeyIcon} locale={locale} />
            </RegistrationContainer>
          )}

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=""
          content={modalContent}
          link={modalLink}
          className="alert-msg-container"
          InnerClassName="alert-msg"
        />
      </>
    );
  };

  return <>{formFields()}</>;
};

export default VerifyOTP;
